import React from 'react';
import { StyledBundlePrice, StyledBundlePriceButton } from './style';
import { PMBundlePriceProps } from 'utils/types';
import { ActualPrice } from 'components/BundlePrice/ActualPrice';

export const EvergreenDynamicBundlePrice: React.FC<PMBundlePriceProps> = ({
  prices,
}) => {
  return (
    <StyledBundlePriceButton className="evergreen-dynamic-bundle__price-button">
      <StyledBundlePrice>
        <div className="evergreen-dynamic__price-button totalPrice">
          <ActualPrice prices={prices} textShadow={'0px 0px 2px #2b2b2b'} />
        </div>
      </StyledBundlePrice>
    </StyledBundlePriceButton>
  );
};
